<template>
  <div class="forgot-password-form">
    <v-form @submit.prevent="handleForgotPassword" ref="forgotForm" v-model="formValid">
      <h2 class="text-h5 text-center mb-6 font-weight-medium">
        Reset Password
      </h2>
      
      <p class="text-body-2 text-medium-emphasis text-center mb-6">
        Enter your email address and we'll send you a link to reset your password.
      </p>
      
      <v-text-field
        v-model="form.email"
        label="Email Address"
        type="email"
        prepend-inner-icon="mdi-email"
        :rules="emailRules"
        required
        autofocus
        class="mb-4"
      />
      
      <v-btn
        type="submit"
        block
        size="large"
        :loading="loading"
        :disabled="!formValid"
        class="mb-4"
      >
        Send Reset Link
      </v-btn>
      
      <div class="text-center">
        <router-link
          to="/auth/login"
          class="text-decoration-none text-primary"
        >
          Back to Sign In
        </router-link>
      </div>
    </v-form>
  </div>
</template>

<script>
import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useToast } from 'vue-toastification'

export default {
  name: 'ForgotPassword',
  setup() {
    const router = useRouter()
    const toast = useToast()
    
    const forgotForm = ref(null)
    const formValid = ref(false)
    const loading = ref(false)
    
    const form = reactive({
      email: ''
    })
    
    const emailRules = [
      v => !!v || 'Email is required',
      v => /.+@.+\..+/.test(v) || 'Email must be valid'
    ]
    
    const handleForgotPassword = async () => {
      if (!formValid.value) return
      
      loading.value = true
      
      try {
        // TODO: Implement forgot password API call
        await new Promise(resolve => setTimeout(resolve, 2000)) // Simulate API call
        
        toast.success('Password reset link has been sent to your email.')
        router.push('/auth/login')
      } catch (error) {
        toast.error('Failed to send reset link. Please try again.')
      } finally {
        loading.value = false
      }
    }
    
    return {
      forgotForm,
      formValid,
      loading,
      form,
      emailRules,
      handleForgotPassword
    }
  }
}
</script>

<style scoped lang="scss">
.forgot-password-form {
  width: 100%;
}

.v-btn {
  text-transform: none;
  font-weight: 500;
}

.text-primary {
  color: rgb(var(--v-theme-primary)) !important;
}

.text-medium-emphasis {
  opacity: 0.7;
}
</style>